<template>
  <Flex
    v-if="customerMember"
    :class="$style.member"
    direction="column"
    :gap=".5"
  >
    <BaseHeading size="xs">{{ $t('customer_details.booked_for') }}</BaseHeading>
    <BaseText v-test="'customer-member'">
      {{ customerMember.firstName }}
      {{ customerMember.lastName }}
    </BaseText>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import type { CustomerMember } from '@/types';

defineProps<{
  customerMember?: CustomerMember;
}>();
</script>

<style
  lang="scss"
  module
>
.member {
  padding: $spacing * .5 0;
}
</style>
